var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion-group" },
    _vm._l(_vm.content, function(accordion, index) {
      return _c("div", { staticClass: "accordion" }, [
        _c(
          "div",
          {
            staticClass: "accordion-title collapsed",
            attrs: {
              "data-toggle": "collapse",
              "data-target": "#" + _vm.prefix + "-" + index,
              "aria-controls": _vm.prefix + "-" + index
            }
          },
          [
            _vm._v(
              _vm._s(_vm.lodash.get(_vm.translate, accordion.title)) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "accordion-content collapse",
          attrs: { id: _vm.prefix + "-" + index },
          domProps: {
            innerHTML: _vm._s(_vm.lodash.get(_vm.translate, accordion.content))
          }
        })
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71b17a66", { render: render, staticRenderFns: staticRenderFns })
  }
}